module.exports = __webpack_public_path__ + "fonts/Gibson.2064ff94.woff2";